import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

gsap.registerPlugin(ScrollToPlugin);

const header = document.querySelector('.site-header');
const actionBar = document.querySelector('.action-bar');
const taxNavPrimary = document.querySelectorAll(
  '.taxNav-primary .menu-item-has-children .sub-menu-tertiary-desc',
);
const primaryNavItems = document.querySelectorAll('ul.primaryNav > li');
const taxNavPrimaryItems = document.querySelectorAll('.taxNavWrap .taxNav-primary li');
const taxNavSecondaryItems = document.querySelectorAll('.taxNavWrap .taxNav-secondary li a');

const setActiveClass = (elem) => {
  elem.classList.remove('inactive');
  elem.classList.add('active');

  elem.querySelector('a[aria-expanded="false"]')?.setAttribute('aria-expanded', 'true');
};

const setInactiveClass = (elem) => {
  elem.classList.remove('active');
  elem.classList.add('inactive');

  elem.querySelector('a[aria-expanded="true"]')?.setAttribute('aria-expanded', 'false');
};

const closeTaxNav = () => {
  Array.from(taxNavPrimaryItems).forEach((elem) => {
    setInactiveClass(elem);
  });
};

const closePrimary = () => {
  Array.from(primaryNavItems).forEach((elem) => {
    if (elem.querySelector('.sub-menu--mega-menu')) {
      return;
    }

    setInactiveClass(elem);
  });
};

const handleItemClick = (e) => {
  const { target } = e;
  if (target.hash === '') {
    return;
  }

  if (
    target.href.substring(0, target.href.indexOf('#')) !==
    window.location.href.substring(0, window.location.href.indexOf('#'))
  ) {
    return;
  }

  e.preventDefault();

  const sections = document.querySelectorAll(`[id="${target.hash.substring(1)}"]`);
  let sectionToScroll = null;
  Array.from(sections).forEach((section) => {
    if (section.offsetTop !== 0) {
      sectionToScroll = section;
    }
  });

  let additionalOffset = -40;
  if (actionBar.classList.contains('fixed')) {
    additionalOffset = 20;
  }

  if (sectionToScroll.classList.contains('section--no-spacing')) {
    additionalOffset = 30;
  }

  if (sectionToScroll !== null && header !== null) {
    closeTaxNav();
    closePrimary();

    gsap.to(window, {
      duration: 0.6,
      scrollTo: {
        y: sectionToScroll.offsetTop,
        offsetY: header.offsetHeight + actionBar.offsetHeight + additionalOffset,
      },
    });
  }
};

const createCloseBtn = () => {
  Array.from(taxNavPrimary).forEach((el) => {
    const closeBtn = document.createElement('a');
    closeBtn.className = 'closeBtn';
    el.appendChild(closeBtn);
  });
};

createCloseBtn();

document.addEventListener('click', (e) => {
  const { target } = e;
  const targetParent = target.parentElement;

  // Exit out if close button clicked.
  if (target.classList.contains('closeBtn')) {
    closeTaxNav();
    closePrimary();
  }

  // Handle primary menu items.
  else if (targetParent !== null && targetParent.classList.contains('primaryNav')) {
    if (target.classList.contains('inactive')) {
      closeTaxNav();
      closePrimary();

      setActiveClass(target);

      const firstSubItem = target.querySelector(
        '.sub-menu-wrap--investments .taxNav-primary .menu-item:first-of-type',
      );
      if (firstSubItem) {
        setActiveClass(firstSubItem);
      }
    } else if (target.classList.contains('active')) {
      setInactiveClass(target);
      closeTaxNav();
    }
  }

  // Handle the primary tax nax section.
  else if (targetParent !== null && targetParent.classList.contains('taxNav-primary')) {
    if (target.classList.contains('menu-item-has-children')) {
      e.preventDefault();
    }

    Array.from(taxNavPrimaryItems).forEach((elem) => {
      setInactiveClass(elem);
    });

    if (target.classList.contains('inactive')) {
      setActiveClass(target);
    } else if (target.classList.contains('active')) {
      setInactiveClass(target);
    }
  }

  // Prevent redirecting to the page if clicked on tax nav arrow.
  else if (target.tagName === 'path' && target.parentElement.hasAttribute('aria-expanded')) {
    e.preventDefault();
    const closestMenuItem = target.closest('.menu-item-has-children');

    Array.from(taxNavPrimaryItems).forEach((elem) => {
      setInactiveClass(elem);
    });

    if (target.closest('.menu-item-has-children') !== null) {
      if (target.closest('.menu-item-has-children').classList.contains('inactive')) {
        setActiveClass(closestMenuItem);
      } else if (target.closest('.menu-item-has-children').classList.contains('active')) {
        setInactiveClass(closestMenuItem);
      }
    }
  }

  // Close nav if not clicking on nav items.
  else if (
    !target.classList.contains('taxNav-primary') &&
    !target.classList.contains('taxNav-secondary') &&
    !target.classList.contains('menu-item') &&
    !targetParent.classList.contains('taxNav-primary') &&
    !targetParent.classList.contains('taxNav-secondary') &&
    !targetParent.classList.contains('menu-item')
  ) {
    closePrimary();
    closeTaxNav();
  }
});

Array.from(taxNavSecondaryItems).forEach((el) => {
  el.addEventListener('click', handleItemClick);
});
